// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field[data-v-3663cafe]{margin-bottom:15px}.label[data-v-3663cafe]{text-transform:uppercase;font-weight:500;font-size:11px}", ""]);
// Exports
module.exports = exports;
